module.exports = __webpack_public_path__ + "static/footer-about-bg-left-bd536f4dca75590b8e6ce8d9e3f896e8.jpg";